import NotFound from "./views/404.vue"
import Home from "./views/Home.vue"

import Zones from "./views/Zones.vue"
import ZonesDashboard from "./views/ZonesDashboard.vue"
import ZoneInfo from "./views/ZoneInfo.vue"
import ZoneNotes from "./views/Notes.vue"
import ZoneAlarms from "./views/ZoneAlarms.vue"
import ZoneLogs from "./views/ZoneLogs.vue"
import UsersManager from "./views/Users.vue"
import ZoneUsers from "./views/ZoneUsers.vue"
import AddZone from "./views/AddZone.vue"
import Profile from "./views/Profile.vue"

import ApartmentSensors from "./views/ApartmentSensors.vue"
import ArchiveLocal from "./views/Archive.vue"

import Main from "./views/Main.vue"

import Form from "./views/nav1/Form.vue"

import HeatSettings from "./views/settings/Heat.vue"
import MotorSettings from "./views/settings/Motor.vue"
import HeatBalancerSettings from "./views/settings/HeatBalancer.vue"
import ApartmentAverageSettings from "./views/settings/ApartmentAverage.vue"
import AutoHeatAdjustSettings from "./views/settings/AutoHeatAdjust.vue"
import CompensatorSettings from "./views/settings/Compensator.vue"
import ReturnLineSettings from "./views/settings/ReturnLine.vue"
import DifferentialSettings from "./views/settings/Differential.vue"
import ProgramMode from "./views/settings/ProgramMode.vue"
import TemperatureSensors from "./views/settings/TemperatureSensors.vue"
import PressureSensors from "./views/settings/PressureSensors.vue"
import NetworkSettings from "./views/settings/Network.vue"
import SystemSettings from "./views/settings/System.vue"
import Callback from "./views/Callback.vue"

import Page4 from "./views/nav2/Page4.vue"
import Page5 from "./views/nav2/Page5.vue"
import Page6 from "./views/nav3/Page6.vue"
import echarts from "./views/charts/echarts.vue"
//Custom
import Dashboard from "./views/Dashboard.vue"

let routes = [
  {
    path: "/",
    redirect: "/Dashboard",
    hidden: true
  },
  {
    path: "/callback",
    component: Callback,
    name: "Callback",
    hidden: true
  },
  {
    path: "/404",
    component: NotFound,
    name: "",
    hidden: true
  },

  {
    path: "/",
    component: Home,
    name: "Dash",
    iconCls: "fa fa-home",
    leaf: true, //只有一个节点
    children: [{ path: "/Dashboard", component: Dashboard, name: "Dashboard" }]
  },
  {
    path: "/",
    component: Home,
    name: "Settings",
    iconCls: "fa fa-cogs", //图标样式class
    children: [
      { path: "/HeatSettings", component: HeatSettings, name: "Heat" },
      { path: "/MotorSettings", component: MotorSettings, name: "Valve" },
      { path: "/HeatBalancerSettings", component: HeatBalancerSettings, name: "Heat Balancer" },
      { path: "/AutoHeatSettings", component: AutoHeatAdjustSettings, name: "Auto Heat" },
      { path: "/CompensatorSettings", component: CompensatorSettings, name: "Compensator" },
      { path: "/ReturnLineSettings", component: ReturnLineSettings, name: "Return Line" },
      { path: "/DifferentialSettings", component: DifferentialSettings, name: "Differential" },
      { path: "/TemperatureSensorSettings", component: TemperatureSensors, name: "Temperature Sensors", hidden: false },
      { path: "/PressureSensorSettings", component: PressureSensors, name: "Pressure Sensors", hidden: false },
      { path: "/ProgramMode", component: ProgramMode, name: "Program mode", hidden: false },
      { path: "/NetworkSettings", component: NetworkSettings, name: "Network", hidden: true },
      { path: "/SystemSettings", component: SystemSettings, name: "System", hidden: false },
      { path: "/ApartmentAverageSettings", component: ApartmentAverageSettings, name: "Apartment Average" }

    ]
  },

  {
    path: "/",
    component: Home,
    name: "Dash",
    iconCls: "fa fa-history",
    leaf: true, //只有一个节点
    children: [{ path: "/ArchiveLocal", component: ArchiveLocal, name: "Zone History" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-info",
    name: "Zone Notes",
    leaf: true, //只有一个节点
    children: [{ path: "/Notes", component: ZoneNotes, name: "Zone Notes" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-info",
    name: "Zone Alarms",
    leaf: true, //只有一个节点
    children: [{ path: "/ZoneAlarms", component: ZoneAlarms, name: "Zone Alarms" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-info",
    name: "Zone Logs",
    leaf: true, //只有一个节点
    children: [{ path: "/ZoneLogs", component: ZoneLogs, name: "Zone Logs" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-info",
    name: "ZoneInfo",
    leaf: true, //只有一个节点
    children: [{ path: "/ZoneInfo", component: ZoneInfo, name: "Zone Info" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-info",
    name: "ZoneUsers",
    leaf: true, //只有一个节点
    children: [{ path: "/ZoneUsers", component: ZoneUsers, name: "Zone Users" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-history",
    name: "Apartment History",
    leaf: true, //只有一个节点
    children: [{ path: "/ApartmentSensors", component: ApartmentSensors, name: "Apartments History" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-building",
    name: "ZonesDashboard",
    leaf: true, //只有一个节点
    children: [{ path: "/ZonesDashboard", component: ZonesDashboard, name: "My Zones" }]
  },
  {
    path: "/",
    component: Home,
    iconCls: "fa fa-building",
    name: "UsersManager",
    leaf: true, //只有一个节点
    children: [{ path: "/Users", component: UsersManager, name: "User Administration" }]
  },
  {
    path: "/",
    component: Home,
    name: "Zones",
    leaf: true, //只有一个节点
    hidden: true,
    children: [{ path: "/Zones", component: Zones, name: "Zones" }]
  },
  {
    path: "/",
    component: Home,
    name: "Add Zone",
    leaf: true, //只有一个节点
    hidden: true,
    children: [{ path: "/AddZone", component: AddZone, name: "AddZone" }]
  },
  {
    path: "/",
    component: Home,
    name: "Profile",
    leaf: true, //只有一个节点
    hidden: true,
    children: [{ path: "/Profile", component: Profile, name: "Profile" }]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js